// Registro de erros de JavaScript do navegador (01/11/2026, alerta do Clarity: "erros de JavaScript que interrompem a
// navegação inicial"). O site não guardava nada — agora cada erro vai para POST /api/public/client-error (sem dado
// pessoal: só a rota sem ?query, o arquivo, a linha e quanto tempo depois de abrir a página). Admin lê em
// GET /api/admin/client-errors. Nunca lança; no máx. 8 erros diferentes por página.
const ENDPOINT = "/api/public/client-error";
const sent = new Set<string>();
let installed = false;

function release(): string {
  try {
    const s = document.querySelector('script[type="module"][src*="/assets/"]') as HTMLScriptElement | null;
    return s?.src ? s.src.split("/").pop() || "" : "";
  } catch { return ""; }
}

export function reportClientError(kind: "error" | "promise" | "react", message: string, extra: { source?: string; line?: number; col?: number; stack?: string } = {}) {
  try {
    const msg = String(message || "").slice(0, 500);
    if (!msg) return;
    const key = `${kind}|${msg}|${extra.source || ""}`;
    if (sent.has(key) || sent.size >= 8) return;
    sent.add(key);
    const body = JSON.stringify({
      kind, message: msg, source: (extra.source || "").split(/[?#]/)[0], line: extra.line, col: extra.col,
      stack: String(extra.stack || "").slice(0, 2000), path: window.location.pathname,
      ms: Math.round(performance.now()), release: release(),
    });
    const blob = new Blob([body], { type: "application/json" });
    if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob)) return;
    fetch(ENDPOINT, { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
  } catch { /* nunca quebra a página */ }
}

export function installErrorReporter() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("error", (e: ErrorEvent | Event) => {
    // Falha ao baixar imagem/CSS (alvo é um elemento) não é erro de JavaScript.
    if (!(e instanceof ErrorEvent)) return;
    const err = e.error as Error | undefined;
    reportClientError("error", e.message || err?.message || "Erro", { source: e.filename, line: e.lineno, col: e.colno, stack: err?.stack });
  });
  window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => {
    const r = e.reason as { message?: string; stack?: string } | string | undefined;
    // Pedido à API que falhou (axios) já tem tratamento na tela — não é erro de código.
    if (r && typeof r === "object" && ("isAxiosError" in (r as object) || "response" in (r as object))) return;
    const message = typeof r === "string" ? r : r?.message || "Promise rejeitada";
    reportClientError("promise", message, { stack: typeof r === "object" ? r?.stack : undefined });
  });
}
